export default __webpack_public_path__ + "static/media/error.616a387b.png";